module.exports = __webpack_public_path__ + "img/ml.9c354b10.jpg";